import React from "react";
import classNames from 'classnames';
import { isAdminRole } from '../../../utils/mics';

const TaskSidebar = ({ userRole, activeGroup, setActiveGroup }) => {
    const isAdmin = isAdminRole(userRole);
    const styles = {
        sidebar: {
            width: '202px',
            boxShadow: '0px 4px 10px 0px rgba(0, 0, 0, 0.25)',
        },
        header: {
            borderBottom: '1px solid #CFD4D9',
        }
    };
    const renderTaskGroup = (group, label) => (
        <div
            className={classNames('side-title task-group flex p-13 cursor-pointer w-202px', { active: activeGroup === group })}
            onClick={() => setActiveGroup(group)}
        >
            {label}
        </div>
    );

    return (
        <div className="child-sidebar" style={styles.sidebar}>
            <div className="side-title p-13 w-202px" style={styles.header}>
                <span className="chat-title">Messages</span>
            </div>

            {isAdmin && (
                <>
                    {renderTaskGroup('site', 'All Messages')}
                    {renderTaskGroup('draft', 'Draft Messages')}
                    {renderTaskGroup('DELETED', 'Deleted Messages')}
                </>
            )}
            {renderTaskGroup('mytask', 'Messages Assigned To Me')}
        </div>
    );
};

export default TaskSidebar;
